<template>
  <div class="coupon-list-body" :class="displayModeClassName">
    <!-- 优惠券列表 -->
    <CouponCard
      v-for="(data, index) in couponsData"
      class="card-item"
      :key="index"
      :data="data"
      :selectedCoupons="selectedCoupons"
      @click="handleChoice"
    />
    <!-- 折叠|展开 -->
    <div
      class="fold flex-center"
      v-show="coupons.length > 2"
      @click="switchFold"
    >
      <span class="text" :style="mFontColor">
        {{ isFold ? $t('common.unfold') : $t('common.fold') }}
      </span>
      <MBIcon
        name="icon-black-arrow"
        :class="isFold ? '' : 'up-arrow'"
        :size="14"
        :color="mFontColor.color"
      />
    </div>
  </div>
</template>
<script>
  // 优惠券列表 - PC
  import MBIcon from '@/components/MBIcon'
  import CouponCard from './CouponCard'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import {
    isValidTime,
    updateCouponSelected,
    checkSelectedIsOverlay,
    switchSelectedCoupon,
  } from '../utils'
  import { mapGetters } from 'vuex'

  export default {
    mixins: [styleConfiguration],
    props: {
      // v-mode 是否展示弹窗
      value: {
        type: Boolean,
        default: false,
      },
      // 全部的优惠券数据
      coupons: {
        type: Array,
        default: () => {},
      },
      // 优惠后价格
      couponAfterMoney: {
        type: [String, Number],
        default: 0,
      },
    },
    components: {
      CouponCard,
      MBIcon,
    },
    data() {
      return {
        show: this.value,
        couponDatas: this.coupons,
        isFold: true, // 是否折叠，默认折叠
      }
    },
    computed: {
      ...mapGetters(['displayModeClassName']),
      selectedCoupons() {
        // 已经选中的优惠券
        return this.couponDatas.filter((item) => item.selected)
      },
      couponsData() {
        if (this.isFold) {
          return this.coupons.slice(0, 2)
        }
        return this.coupons
      },
    },
    watch: {
      value(val) {
        this.show = val
      },
      show(val) {
        this.$emit('input', val)
      },
      coupons(val) {
        this.couponDatas = val
      },
      selectedCoupons: {
        handler(val) {
          this.$emit('onSelectedCoupons', val)
        },
        deep: true,
      },
    },
    methods: {
      switchFold() {
        // 切换折叠状态
        this.isFold = !this.isFold
      },
      handleChoice(data) {
        // 选中/切换优惠券
        // 如果当前券是不可用优惠券，或者不在有效期内不可选中
        if (!data.webEnable || !isValidTime(data)) return
        // 如果用户选择的券都是可以叠加的，且总金额大于或者等于商品价格的时候，不再支持勾选，但是支持取消
        if (
          this.couponAfterMoney < data.conditionPrice &&
          checkSelectedIsOverlay(this.coupons, data)
        ) {
          this.couponDatas = switchSelectedCoupon(this.coupons, data)
          return
        }
        this.couponDatas = updateCouponSelected(this.coupons, data)
      },
    },
  }
</script>

<style lang="scss" scoped src="./index_pc.scss"></style>
